import { Component, ViewChild, EventEmitter, Output } from '@angular/core';
import { CoEventsExploreComponent } from '../co-events-explore/co-events-explore';
import { Platform } from 'ionic-angular/platform/platform';
import { AppState } from '../../config/state';
import { CoEventsExploreDesktopComponent } from '../co-events-explore-desktop/co-events-explore-desktop';
/**
 * Generated class for the CoExploreEventsBlockComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-explore-events-block',
  templateUrl: 'co-explore-events-block.html',
  inputs: ['popOverFilter', 'clientKeyword']
})
export class CoExploreEventsBlockComponent {

  @ViewChild(CoEventsExploreComponent) innerEventsList: CoEventsExploreComponent;
  @ViewChild(CoEventsExploreDesktopComponent) desktopEventsList: CoEventsExploreComponent;
  searchTypes: any = [];
  currentDensity: number = 1;
  densityButtons: any;
  currentTypeFilter: string = 'All';
  viewType: string = this.state.mode;
  @Output() changeViewAndFilter = new EventEmitter<any>();

  constructor(public platform: Platform, public state: AppState) {
    // this.initializeBlock();
    // this.densityButtons = document.getElementsByClassName('densityButton');
  }

  // async initializeBlock() {
  //   await this.platform.ready();
  //   if (this.viewType != 'desktop'){
  //     this.innerEventsList.getExploreEvents();
  //     this.changeDensity(1);
  //   }

  // }

  // applyingFiltersFromExploreComponent(filters){
  // return this.innerEventsList.filterByPopOver(filters)
  // }

  // updateFilterScrollList() {
  // this.searchTypes = this.innerEventsList.getFilterList();
  // console.log('the search types?', this.searchTypes)
  // }

  // filterEventsList(typeName, event) {
  // this.innerEventsList.filterEventsList(typeName, event);
  // typeName.length > 0? this.currentTypeFilter = typeName : this.currentTypeFilter = 'All';
  // }

  // changeDensity(density: number) {
  //   this.currentDensity = density;
  //   let className = "density" + density.toString();
  //   let allEventViews = document.getElementsByClassName('eventView');
  //   allEventViews[allEventViews.length-1].className = (className + " eventView");
  //   this.currentDensity = density;

  //   Array.prototype.forEach.call(this.densityButtons, function(button, i){
  //     if (`density_${i+1}` != `density_${density}`) {
  //       button.className = "densityButton";
  //       button.className += " nonActive";
  //     } else {
  //       button.className = "densityButton";
  //     };
  //   });
  // }

  // transferEventTypes(event){
  // }

  // passUpMoreEventsClick(params){
  //   this.changeViewAndFilter.emit(params);
  // }

}



// WEBPACK FOOTER //
// ./src/components/co-explore-events-block/co-explore-events-block.ts